import axios from "axios";
const url = process.env.REACT_APP_URL;

const getAllUsers = () => {
  return axios
    .get(`${url}/users/all-users`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(`Could not get all users: ${err}`);
      return [];
    });
};

const getAllAssets = (page) => {
  return axios
    .get(`${url}/assets/all-assets?page=${page}`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(`Could not get all assets: ${err}`);
      return [];
    });
};

const getAssetLocations = () => {
  return axios
    .get(`${url}/assets/asset-locations`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(`Could not get all asset locations: ${err}`);
      return [];
    });
};

const getAssetTypes = () => {
  return axios
    .get(`${url}/assets/asset-types`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(`Could not get all assets types: ${err}`);
      return [];
    });
};

const getUserAccessLevels = () => {
  return axios
    .get(`${url}/users/access-levels`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(`Could not get user access levels: ${err}`);
      return [];
    });
};

const getCompanies = () => {
  return axios
    .get(`${url}/assets/companies`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(`Could not get companies: ${err}`);
      return [];
    });
};

export {
  getAllUsers,
  getAllAssets,
  getUserAccessLevels,
  getAssetLocations,
  getAssetTypes,
  getCompanies,
};
